import React from 'react'

import useThemeSettings from 'customizer/theme/useThemeSettings'
import Checkmark from 'icons/custom/checkmark.svg'

import OutOfStockBadge from './../answers/OutOfStockBadge'
import Translation from '../Translation'

import './SummaryDrawerStepStatus.scss'

export type SummaryDrawerStepStatusProps = {
  isRequired?: boolean
  isOutOfStock?: boolean
  hasError?: boolean
  visited?: boolean
}

const SummaryDrawerStepStatus = ({ isRequired, visited, hasError, isOutOfStock }: SummaryDrawerStepStatusProps) => {
  const { visitedIconColor } = useThemeSettings('summaryDrawer')

  const showRequiredError = isRequired && hasError
  const showOutOfStock = !showRequiredError && isOutOfStock
  const showCheckmark = !showRequiredError && !showOutOfStock && visited
  const showRequiredWarning = !showRequiredError && !showOutOfStock && !showCheckmark && isRequired
  const showStatus = showRequiredError || showOutOfStock || showCheckmark || showRequiredWarning

  if (!showStatus) return null

  return (
    <span className="summary-drawer__step-status">
      {showRequiredError && <Translation className="summary-drawer__step-status--error" field="requiredWarning" />}

      {showOutOfStock && (
        <OutOfStockBadge className="summary-drawer__step-status--icon summary-drawer__step-status--out-of-stock" />
      )}

      {showCheckmark && (
        <Checkmark
          aria-label="checkmark"
          className="summary-drawer__step-status--icon"
          style={{ fill: visitedIconColor }}
        />
      )}

      {showRequiredWarning && <Translation field="requiredWarning" />}
    </span>
  )
}

export default SummaryDrawerStepStatus
